export default "__VITE_ASSET__eb07d5a2__"